import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  GET_THERAPIST_INFO_REQUEST,
  GET_THERAPIST_INFO_SUCCESS,
  GET_THERAPIST_INFO_FAILURE,
  GET_THERAPIST_INFO_RESET,
  GET_THERAPIST_INFO_LOADING,
} = documentationActions;

function* getTherapistInfo(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_THERAPIST_INFO_LOADING });
    const response = yield call(templateService.getTherapistInfo, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_THERAPIST_INFO_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_THERAPIST_INFO_FAILURE, payload: error });
  }
}

function* getTherapistInfoSaga() {
  yield takeEvery(GET_THERAPIST_INFO_REQUEST, getTherapistInfo);
}

export default getTherapistInfoSaga;
